import React from "react"

import { RouteObject } from "react-router-dom"

import { ErrorPage } from "~/src/components/ErrorPage"
import {
  QuickSendConfirmationContent,
  QuickSendConfirmationContentProps,
} from "~/src/components/QuickSends/QuickSendConfirmationContent"
import {
  QuickSendEditDetailsContent,
  QuickSendEditDetailsContentProps,
} from "~/src/components/QuickSends/QuickSendEditDetailsContent"
import {
  QuickSendEditSelectionsContent,
  QuickSendEditSelectionsContentProps,
} from "~/src/components/QuickSends/QuickSendEditSelectionsContent"
import {
  QuickSendEditStoreContent,
  QuickSendEditStoreContentProps,
} from "~/src/components/QuickSends/QuickSendEditStoreContent"
import { QuickSendReviewContent, QuickSendReviewContentProps } from "~/src/components/QuickSends/QuickSendReviewContent"
import { appClient } from "~/src/lib/appClients"

const createRoutes = (): RouteObject[] => [
  {
    path: "/quick_sends/:id",
    hydrateFallbackElement: <></>,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "store",
        element: <QuickSendEditStoreContent />,
        async loader({ params }): Promise<QuickSendEditStoreContentProps> {
          const { id } = params

          const response = await appClient.get(`quick_sends/${id}/store.json`, {
            headers: { Accept: "application/json" },
          })

          return response.data
        },
      },
      {
        path: "selections",
        element: <QuickSendEditSelectionsContent />,
        async loader({ request, params }): Promise<QuickSendEditSelectionsContentProps> {
          const { id } = params
          const url = new URL(request.url)

          const response = await appClient.get(`quick_sends/${id}/selections.json`, {
            headers: { Accept: "application/json" },
            params: url.searchParams,
          })

          return response.data
        },
        children: [
          {
            path: ":collectionable_id/modal",
            async loader({ params }) {
              const { id, collectionable_id } = params
              const { data } = await appClient.get(`quick_sends/${id}/selections/${collectionable_id}/modal.json`, {
                headers: { Accept: "application/json" },
              })

              return data
            },
          },
        ],
      },
      {
        path: "details",
        element: <QuickSendEditDetailsContent />,
        async loader({ params }): Promise<QuickSendEditDetailsContentProps> {
          const { id } = params

          const response = await appClient.get(`quick_sends/${id}/details.json`, {
            headers: { Accept: "application/json" },
          })

          return response.data
        },
      },
      {
        path: "review",
        element: <QuickSendReviewContent />,
        async loader({ params }): Promise<QuickSendReviewContentProps> {
          const { id } = params

          const response = await appClient.get(`quick_sends/${id}/review.json`, {
            headers: { Accept: "application/json" },
          })

          return response.data
        },
      },
      {
        path: "confirm",
        element: <QuickSendConfirmationContent />,
        async loader({ params }): Promise<QuickSendConfirmationContentProps> {
          const { id } = params

          const response = await appClient.get(`quick_sends/${id}/confirm.json`, {
            headers: { Accept: "application/json" },
          })

          return response.data
        },
      },
    ],
  },
]

export default createRoutes
